@if (currentCompany$ | async; as company) {
  <span class="text-lg truncate">{{ company?.name }}</span>
}
